import apiService from "./apiService";
import AppConstants from "../appConstants";

class HatService {
    getAllHat(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_HAT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getHatDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_HAT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerHat(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_HAT, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteHat(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_HAT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_HAT_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new HatService();
